exports.company = "priosafe";
